module.exports = __webpack_public_path__ + "img/helpscout.77f2dd44.png";